module.exports = __webpack_public_path__ + "static/media/client.3edee37c.svg";